import { render } from "./Investments.vue?vue&type=template&id=d2dcee24"
import script from "./Investments.vue?vue&type=script&lang=js"
export * from "./Investments.vue?vue&type=script&lang=js"
script.render = render

export default script